import React from 'react';
import Select, { components } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { InvoiceReportService } from '../../services/InvoiceReportService';

const ClientDropDown = ({ lockboxformik, isSingle = false, width = "250px", name = "clients", isPartner = true, isDisabled = false, isDisableOnchange = false }) => {
	const [isFocusedClient, setIsFocusedClient] = useState(false);
	const [clients, setClients] = useState([]);
	const [isLoadingClients, setIsLoadingClients] = useState(false);

	const invoiceReportService = new InvoiceReportService();
	const { getClientPartnerDropdown } = invoiceReportService;

	const DropdownIndicator = ({ state, ...props }) => {
		return (
			<components.DropdownIndicator {...props}>
				{isLoadingClients ? (
					<FaSpinner className="spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
				) : lockboxformik.values?.[state]?.length > 1 ? (
					<TbGridDots style={{ fontSize: "1.5em" }} />
				) : (
					<HiChevronDown style={{ fontSize: "1.5em" }} />
				)}
			</components.DropdownIndicator>
		);
	};

	useEffect(() => {
		let apiTimeout = null;

		if (isPartner && lockboxformik?.values?.partners?.length === 0) {
			lockboxformik.setFieldValue(name, []);
		}

		setIsLoadingClients(true);

		apiTimeout = setTimeout(() => {
			const partnerIds = lockboxformik?.values?.partners || [];
			getClientPartnerDropdown(partnerIds?.length > 0 ? partnerIds : null).then((response) => {
				setIsLoadingClients(false);

				if (response?.status) {
					const apiResponse = response?.data?.partners || [];
					const selectedClientIds = apiResponse.flatMap(i => i?.clients)?.map(ite => ite.value);
					const filterClients = lockboxformik?.values?.[name]?.filter(i => selectedClientIds.includes(i));

					if (isPartner && lockboxformik?.values?.partners?.length > 0) {
						lockboxformik.setFieldValue(name, filterClients || []);
					}

					setClients(
						apiResponse.map((result) => ({
							options: result?.clients,
							label: result?.partner,
							id: result?.pk
						}))
					);
				}
			});
		}, 600);

		return () => clearTimeout(apiTimeout);
	}, [lockboxformik?.values?.partners]);

	const handleChange = (e) => {
		lockboxformik.setFieldValue(name, !isSingle ? e.map(i => i.value) : [e?.value]);
	};

	const value = !isSingle
		? clients?.flatMap(i => i?.options)?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value))
		: clients[0]?.options?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value));

	return (
		<div style={{ width: `${width}` }}>
			<Form.Group>
				<Select
					className="basic-single select-search-facility-component"
					classNamePrefix="select"
					isDisabled={isLoadingClients || isDisabled}
					isMulti={!isSingle}
					tabSelectsValue={false}
					closeMenuOnSelect={isSingle}
					value={value}
					name={name}
					menuPortalTarget={document.body}
					components={{
						DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} />
					}}
					options={clients}
					onFocus={() => setIsFocusedClient(true)}
					onBlur={() => setIsFocusedClient(false)}
					onChange={isDisableOnchange ? undefined : handleChange}
					placeholder="Clients"
					styles={{
						container: (styles) => ({
							...styles,
							borderRadius: "9px"
						}),
						control: (styles, state) => ({
							...styles,
							backgroundColor: "hsl(204deg 33.33% 97.06%)",
							borderStyle: "none",
							boxShadow: "none",
							borderRadius: "10px",
							maxHeight: state.isFocused ? "auto" : "30px"
						}),
						indicatorSeparator: (styles) => ({
							...styles,
							width: "0px",
							minHeight: "20px"
						}),
						valueContainer: (styles, state) => ({
							...styles,
							maxHeight: isFocusedClient ? "auto" : "30px"
						}),
                        placeholder: (styles) => ({
                            ...styles,
                            fontSize: "12px"   // increase placeholder font size
                        }),
						menuPortal: base => ({ ...base, zIndex: 9999 })
					}}
				/>
				{lockboxformik.errors?.[name] &&
					<span className='text-danger'>{lockboxformik.errors?.[name]}</span>
				}
			</Form.Group>
		</div>
	);
};

export default React.memo(ClientDropDown);
